const families = {
  primary: "'Figtree', 'Arial'",
  header: "'Figtree Bold'",
  secondary: "'Figtree Medium'",
  bold: "'Figtree Semibold'",
  light: "'Figtree Light'",
}

export default families
